import { useCallback } from 'react';
import { showStaleVersionToast } from './toast';
import { useAppVersionMonitor } from './useAppVersionMonitor';
import type { AppVersionInfo } from './version';

export interface AppVersionMonitorProps {
  /**
   * Called when the deployed version differs from the loaded baseline.
   * Omit to use the built-in react-toastify fallback toast.
   */
  onStaleVersion?: (remote: AppVersionInfo) => void;
}

/**
 * Polls for deployed version updates and shows a refresh toast when stale.
 * Render once near the app root when your feature flag is on.
 * Requires react-toastify ToastContainer when using the default toast.
 */
export function AppVersionMonitor({
  onStaleVersion: onStaleVersionProp,
}: AppVersionMonitorProps = {}): null {
  const onStaleVersion = useCallback(
    (remote: AppVersionInfo) => {
      if (onStaleVersionProp) {
        onStaleVersionProp(remote);
        return;
      }

      showStaleVersionToast({
        onRefresh: () => window.location.reload(),
      });
    },
    [onStaleVersionProp],
  );

  useAppVersionMonitor({
    enabled: true,
    onStaleVersion,
  });

  return null;
}
